var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMastercard = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("rect", {
    y: 0.00000762939,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#34495E"
  }), React.createElement("path", {
    d: "M13.0256 10.4541H18.9741V21.1425H13.0256V10.4541Z",
    fill: "#FF5F00"
  }), React.createElement("path", {
    d: "M13.4034 15.7983C13.4034 13.6266 14.4232 11.7004 15.9906 10.4541C14.8386 9.54764 13.3845 9 11.7983 9C8.04034 9 5 12.0403 5 15.7983C5 19.5562 8.04034 22.5966 11.7983 22.5966C13.3845 22.5966 14.8386 22.0489 15.9906 21.1425C14.4232 19.915 13.4034 17.97 13.4034 15.7983Z",
    fill: "#EB001B"
  }), React.createElement("path", {
    d: "M27.0001 15.7983C27.0001 19.5562 23.9597 22.5966 20.2018 22.5966C18.6155 22.5966 17.1615 22.0489 16.0095 21.1425C17.5958 19.8961 18.5966 17.97 18.5966 15.7983C18.5966 13.6266 17.5769 11.7004 16.0095 10.4541C17.1615 9.54764 18.6155 9 20.2018 9C23.9597 9 27.0001 12.0592 27.0001 15.7983Z",
    fill: "#F79E1B"
  }));
};
export default SvgMastercard;